import gql from "fraql";
import { ref } from "vue";
import CapitalizeName from "@/utils/capitalizeName";
import { locales } from "./misc";
import i18next from "i18next";
import { apolloClient } from "@/plugins/apollo";
import FederationConfig from "@/plugins/federationConfig";
export const FederationConfigurationFragment = gql `
  fragment _ on FederationConfiguration {
    countryId
    country {
      id
      name
      alpha2
      ioc
    }
    outsideOfCompetitionRule
    frontendDisplayLastNameBeforeFirst
    currency
    translatedLanguages
    defaultLanguage
    featureFlags
    openidLoginPath
    horseTemporaryLicenceDefaultLength
    useOnlinePayments
    useOnlinePaymentsForPrizeMoney
    useEquipe
    availableEntryResolutions
    feiPublicRegistrationDisabled
    collectEntryBillingContact
  }
`;
export function localPercent(val, countryCode) {
    if (!val)
        return;
    return new Intl.NumberFormat(locales[countryCode], {
        style: "percent",
        maximumFractionDigits: 2
    }).format(parseFloat(String(val)) / 100);
}
export function getFederationConfiguration() {
    var _a, _b;
    const masterConfiguration = ref((_b = (_a = apolloClient.readQuery({
        query: gql `
        query MasterFederationConfiguration {
          federationConfiguration {
            ${FederationConfigurationFragment}
          }
        }
      `
    })) === null || _a === void 0 ? void 0 : _a.federationConfiguration) !== null && _b !== void 0 ? _b : {});
    const outsideOfCompetitionRuleAllowed = masterConfiguration.value.outsideOfCompetitionRule != "NOT_ALLOWED";
    function isFeatureFlagSet(flag) {
        return !!masterConfiguration.value[flag];
    }
    function showDisplayName(person) {
        if (!person)
            return "";
        if (person.firstName || person.lastName) {
            let personName = [];
            if (masterConfiguration.value.frontendDisplayLastNameBeforeFirst) {
                personName = [person.lastName, person.firstName];
            }
            else {
                personName = [person.firstName, person.lastName];
            }
            return CapitalizeName(personName.filter(Boolean).join(" "));
        }
        return person.name;
    }
    function returnLocalisedPercent(val) {
        // @ts-ignore
        return localPercent(val, FederationConfig.countryCode);
    }
    return {
        masterConfiguration,
        outsideOfCompetitionRuleAllowed,
        returnLocalisedPercent,
        showDisplayName,
        isFeatureFlagSet
    };
}
export function masterCurrencyFn(amount, options) {
    if (!isNaN(amount) &&
        (options.allowZero || Number(amount) != 0 || !options.doNotShowZero)) {
        if (!options.notCents)
            amount = amount / 100;
        let locale = locales[options.countryCode];
        if (options.countryCode == "BE") {
            locale = i18next.language;
        }
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: options.currencyNote
        }).format(amount);
    }
    return "";
}
export function useCurrency() {
    function masterCurrency(amount, options = {}) {
        const currencyNote = apolloClient.readQuery({
            query: gql `
        query FederationCurrency {
          federationConfiguration {
            currency
          }
        }
      `
        }).federationConfiguration.currency;
        return masterCurrencyFn(amount, {
            ...options,
            currencyNote,
            countryCode: FederationConfig.countryCode
        });
    }
    return { masterCurrency };
}
